import { render, staticRenderFns } from "./ChildApprovalsSubmitNotification.vue?vue&type=template&id=44226584&scoped=true"
import script from "./ChildApprovalsSubmitNotification.vue?vue&type=script&lang=js"
export * from "./ChildApprovalsSubmitNotification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44226584",
  null
  
)

export default component.exports